import { ProductsSortableFields } from "@dransay/api/models";
import { parseAsStringLiteral, useQueryState } from "nuqs";

export const useSortQuery = () =>
	useQueryState("sort", parseAsStringLiteral(ProductsSortableFields));
